import * as React from 'react';
import { Hero } from '@brightlayer-ui/react-components/core';
import { Data, isDataLoading, isDataLoaded } from '../../types/data-providers';
import { getIcon } from '../../lib/icons';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { getBatteryIconColor } from '../../data/domain/metric-data-helpers';
import { BatteryStatus } from '../../types';

type SiteBatteryStatus = Data<boolean | null>;

const getBatteryStatusData = (siteBatteryStatus: Data<boolean | null>): { value: BatteryStatus } => {
    if (isDataLoading(siteBatteryStatus) || !isDataLoaded(siteBatteryStatus)) {
        return {
            value: BatteryStatus.Unknown,
        };
    }
    if (isDataLoaded(siteBatteryStatus)) {
        if (siteBatteryStatus.value) return { value: BatteryStatus.Alarm };
        return { value: BatteryStatus.Full };
    }
    return { value: BatteryStatus.Unknown };
};

const getStatusText = (value: BatteryStatus): string => {
    switch (value) {
        case BatteryStatus.Alarm:
            return 'DASHBOARD.SITE_DETAILS.READING_CARDS.ALARM';
        case BatteryStatus.Full:
            return 'DASHBOARD.SITE_DETAILS.READING_CARDS.FULL';
        default:
        case BatteryStatus.Unknown:
            return 'DASHBOARD.SITE_DETAILS.READING_CARDS.UNKNOWN';
    }
};

export const BatteryHero: React.FC<{
    siteBatteryStatus: SiteBatteryStatus;
    testId?: string;
}> = (props) => {
    const batteryData = getBatteryStatusData(props.siteBatteryStatus);
    const TheIcon = getIcon('BatteryFull');
    const { t } = useLanguageLocale();

    return (
        <div data-testid={props.testId}>
            <Hero
                icon={<TheIcon fontSize="large" style={{ color: getBatteryIconColor(batteryData.value) }} />}
                label={t('DASHBOARD.SITE_DETAILS.READING_CARDS.BATTERY')}
                ChannelValueProps={{ value: t(getStatusText(batteryData.value)) }}
                iconSize="small"
            />
        </div>
    );
};
